import React, { useEffect, Suspense, lazy, useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Cookies from 'js-cookie';
import PageLoading from '../components/common/spinners/PageLoading'
import AdminPage from '../components/common/page/AdminPage'
import NotFound from '../pages/not-found/NotFound '
import { useSelector } from 'react-redux';
import { controllerCalenderTypes } from '../assets/javascript/const-data';


const Home = lazy(() => import('../pages/controller/home/Home'))
const StaffList = lazy(() => import('../pages/controller/staff-list/StaffList'))
const ProspectView = lazy(() => import('../pages/controller/prospect-view/ProspectView'))
const LeadReports = lazy(() => import('../pages/controller/lead-reports/LeadReports'))
const Resources = lazy(() => import('../pages/controller/resources/Resources'))
const SingleOption = lazy(() => import('../pages/controller/resources/SingleOption'))
const CompOption = lazy(() => import('../pages/controller/resources/CompOption'))
const ViewEnquiryForm = lazy(() => import('../pages/controller/view-enquiry-form/ViewEnquiryForm'))
const ViewInstallationForm = lazy(() => import('../pages/controller/view-i-form/ViewInstallationForm'))
const EnquiryReports = lazy(() => import("../pages/controller/enquiry-reports/EnquiryReports"))
const InstallationReports = lazy(() => import('../pages/controller/installation-reports/InstallationReports'))
const ControllerCalendar = lazy(() => import('../pages/controller/calendar/Calendar'))
const ProspectViewV2 = lazy(() => import('../pages/controller/prospect-view/ProspectViewV2'))
const ProspectRoute = lazy(() => import('../pages/controller/prospect-route/ProspectRoute'))
const ReportsLandingPage = lazy(() => import('../pages/controller/reports/ReportsLandingPage'))
const LesList = lazy(() => import('../pages/controller/LesList/LesList'))

const ControllerRouter = () => {
  let isAuthenticated = false
  const [pageHead, setPageHead] = useState({ title: null, desc: null })
  const { user } = useSelector((state) => state.userAuth)
  const rfs_tkn = Cookies.get('_rfs_tkn');
  const DVC_ID = Cookies.get('DVC_ID');

  if (DVC_ID && rfs_tkn) {
    isAuthenticated = true
  }

  useEffect(() => {
    // Change Title
    document.title = `Controller | Sales App | Alliance`;

    // eslint-disable-next-line
  }, [])

  return (
    <AdminPage pageHead={pageHead}>
      <Suspense fallback={<PageLoading />}>
        <Routes>
          {/* Home */}
          <Route path='/' element={<PrivateRoute element={<Home setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

          {/* Staff list */}
          {user?.allowed_origins?.some(access => ['slcr_stfLst_write', 'slcr_stfLst_read'].includes(access)) &&
            <Route path='/sales-team' element={<PrivateRoute element={<StaffList setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />}

          {/* LES List */}
          <Route path='/les_list' element={<PrivateRoute element={<LesList setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
        
          <Route path='/prospect/e-form/:e_form_srl_no' element={<PrivateRoute element={<ViewEnquiryForm setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

       
          <Route path='/prospect/i-form/:installation_srl_no' element={<PrivateRoute element={<ViewInstallationForm setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

          {/* Prospect */}
          <Route path='/prospect/:prospect_id/view' element={<PrivateRoute element={<ProspectView setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
          <Route path='/prospect/:prospect_id/route' element={<PrivateRoute element={<ProspectRoute setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
          <Route path='/prospect/v2/:prospect_id/:work_id/:status_id' element={<PrivateRoute element={<ProspectViewV2 setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

          {/* Reports */}
          <Route path='/reports' element={<PrivateRoute element={<ReportsLandingPage setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
          {user?.allowed_origins?.some(access => ['slcr_leList_write', 'slcr_leList_read'].includes(access)) &&
            <Route path='/reports/leads' element={<PrivateRoute element={<LeadReports setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />}
          {user?.allowed_origins?.some(access => ['slcr_eqList_write', 'slcr_eqList_read'].includes(access)) &&
            <Route path='/reports/enquiry' element={<PrivateRoute element={<EnquiryReports setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />}
          {user?.allowed_origins?.some(access => ['slcr_inList_write', 'slcr_inList_read'].includes(access)) &&
            <Route path='/reports/installation' element={<PrivateRoute element={<InstallationReports setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />}


          {/* Calendar */}
          {user?.allowed_origins?.some(access => controllerCalenderTypes.flatMap(type => type.read_access).includes(access)) && <>
            <Route path='/calendar/:view/:theYear/:theMonth/:theDate' element={<PrivateRoute element={<ControllerCalendar setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
          </>}

          {/* Resources */}
          {user?.allowed_origins?.some(access => ['slcr_reso_write'].includes(access)) && <>
            <Route path='/resources' element={<PrivateRoute element={<Resources setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
            <Route path='/resources/:type/sg/:title' element={<PrivateRoute element={<SingleOption setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
            <Route path='/resources/:type/comp/:title' element={<PrivateRoute element={<CompOption setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
          </>}

          {/* 404 Route */}
          <Route path="/*" element={<NotFound setPageHead={setPageHead} />} />
        </Routes>
      </Suspense>
    </AdminPage >
  )
}

export default ControllerRouter


function PrivateRoute({ element, isAuthenticated, }) {
  return isAuthenticated ? element : window.location.href = 'https://worker.alliancedev.in/?page=home';
}

